const FAQS = [
  {
    q: '91影视看片APP在哪里下载？',
    a: '您可以直接在本站 #app 区域点击安卓下载按钮，获取最新版91影视看片APP的APK安装包。安装前请确保手机已开启"允许安装未知来源应用"的权限设置，下载完成后按提示完成安装即可使用。',
  },
  {
    q: '这款看片软件收费吗？',
    a: '91影视看片APP是一款完全免费的手机影视软件，不收取任何会员费用，无需充值订阅。所有影视内容均免费观看，承诺不设置强制广告弹窗，为用户提供纯净的免费观影体验。',
  },
  {
    q: '支持哪些设备和系统版本？',
    a: '目前91影视看片APP主要支持安卓系统，适配Android 7.0及以上版本的主流机型。包括华为、小米、OPPO、vivo、三星等品牌的手机和平板设备均可正常安装运行。iOS版本正在开发中，敬请期待。',
  },
  {
    q: '可以离线下载观看吗？',
    a: '当然可以。91影视看片APP支持WiFi环境下批量缓存下载功能，您可以在有网络时将喜欢的剧集下载到手机本地，之后在没有流量的环境下（如飞机、地铁）也能畅快追剧，且下载内容永久有效。',
  },
  {
    q: '影片画质怎么样？更新速度快吗？',
    a: 'APP支持4K超清、1080P蓝光等多种画质选项，系统会根据您的网络环境智能匹配最佳清晰度。内容更新方面，热门电视剧和综艺节目通常在播出后2小时内同步上线，电影新片也会第一时间更新资源，每日更新量超过200部。',
  },
  {
    q: '安装后提示安全风险怎么办？',
    a: '由于91影视看片APP为第三方应用，部分手机系统可能会提示安全风险。请放心，我们的安装包经过严格安全检测，不含任何恶意代码。如遇提示，请在手机设置中临时关闭"安全检测"或"纯净模式"，正常安装后重新开启即可。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="w-full py-16 md:py-24 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 bg-secondary-100 text-secondary-700 text-xs font-semibold rounded-full mb-4 whitespace-nowrap">
            常见问答
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            关于91影视看片的常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            解答您在使用看片软件过程中可能遇到的疑问
          </p>
        </div>

        <div className="space-y-3">
          {FAQS.map((faq, i) => (
            <details key={i} className="group bg-background-50 rounded-2xl border border-background-200/60 overflow-hidden">
              <summary className="flex items-center justify-between p-5 md:p-6 cursor-pointer list-none">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 pr-4">{faq.q}</h3>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-background-100 text-foreground-500 group-open:bg-primary-100 group-open:text-primary-600 shrink-0 transition-colors">
                  <i className="ri-add-line group-open:hidden"></i>
                  <i className="ri-subtract-line hidden group-open:block"></i>
                </div>
              </summary>
              <div className="px-5 md:px-6 pb-5 md:pb-6">
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed">{faq.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}